import { render } from "./radio-btn.vue?vue&type=template&id=8cb78f56&scoped=true"
import script from "./radio-btn.vue?vue&type=script&lang=js"
export * from "./radio-btn.vue?vue&type=script&lang=js"

import "./radio-btn.vue?vue&type=style&index=0&id=8cb78f56&lang=less&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb78f56"]])

export default __exports__